import React, { Component, useState, useRef, Fragment } from 'react'
import { useMount } from 'react-use'
import { connect } from 'react-redux'
import Qr from 'qrcode.react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Tabs, Card, Modal, Input, Divider, Upload, Icon, Empty, Button, message } from 'antd'
import styles from './workerDialog.module.scss'
import dayjs from 'dayjs'
import * as actions from '@/models/workers/actions'
import * as apis from '@/apis'
import SelectSkill from './skill'
import ServiceInfo from './serviceInfo'
import SelectArea from '@/components/SelectArea'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@connect()
@Form.create()
class WorkerForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { dispatch, id, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          console.log('errors', errors)
          errors.forEach(({ message: msg }) => {
            console.log('msg:', msg)
            message.error(msg)
          })
        })
        return console.error(err)
      }
      apis.updateWorker(id, values)
        .then(() => {

          dispatch(actions.updated(id, values))
          message.success('保存成功')
        })
        .catch(err => {
          message.error(err.message || '保存失败，请重试')
        })
    });
  }

  render() {
    const { id, worker } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form

    if (!worker) {
      return null
    }

    const page1 = (
      <Fragment>
        <div className={styles.wrap}>
          <div style={{ marginTop: 20 }}>
            <Form.Item
              {...formItemLayout}
              label="真实姓名"
              extra="必须与身份证一致"
              required>
              {getFieldDecorator('realname', {
                initialValue: worker.realname,
                rules: [
                  {
                    required: true,
                    message: '请输入真实姓名',
                  },
                ],
              })(
                <Input autoFocus placeholder="请输入真实姓名" />
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="身份证号"
              required>
              {getFieldDecorator('identity_number', {
                initialValue: worker.identity_number,
                rules: [
                  {
                    required: true,
                    message: '请输入身份证号',
                  },
                ],
              })(
                <Input placeholder="请输入身份证号" />
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="家庭住址">
              {getFieldDecorator('home_address', {
                initialValue: worker.home_address,
              })(
                <Input placeholder="请输入家庭地址" />
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="服务范围">
              {getFieldDecorator('service_area', {
                initialValue: worker.service_area || [],
              })(
                <SelectArea />
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="服务范围补充">
              {getFieldDecorator('bio', {
                initialValue: worker.bio || '',
              })(
                <Input placeholder="请输入服务范围补充" />
              )}
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="入驻时间">
              <span>{dayjs(worker?.createAt).format('YYYY-MM-DD  HH:mm:ss')}</span>
            </Form.Item>
            <Form.Item
              {...formItemLayout}
              label="备注"
              extra="*只有客服与管理员才能看到">
              {getFieldDecorator('memo', {
                initialValue: worker.memo
              })(
                <Input.TextArea rows={3} placeholder="" />
              )}
            </Form.Item>
          </div>
          <div>
            <Divider orientation="left">
              <span className={styles.sectionTit}>审核资料</span>
            </Divider>
            <div style={{ overflow: 'hidden' }}>
              {
                [
                  {
                    label: '身份证 正面',
                    name: 'id_positive'
                  },
                  {
                    label: '身份证 背面',
                    name: 'id_back'
                  },
                  {
                    label: '手持身份证',
                    name: 'hand_held_id'
                  }
                ].map(item => (
                  <div style={{ float: 'left', margin: '0 10px 10px 0' }}>
                    <Card size="small" style={{ width: 170, }}>
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </Card>
                    <div><center style={{ fontSize: 10, lineHeight: 2 }}>{item.label}</center></div>
                  </div>
                ))
              }
              <div className="ant-form-extra" style={{ padding: '20px 0' }}>* 师傅上传的资料不可修改</div>
            </div>
          </div>
        </div>
      </Fragment>
    )

    return (
      <div>
        <Form onSubmit={this.handleSubmit} autoComplete={false}>
          <Tabs
            defaultActiveKey={this.props.tab || '1'}
            className={styles.tabs}
            // onChange={this.tabOnChange}
            type="card">
            <Tabs.TabPane key="1" tab="基本信息">
              {page1}
            </Tabs.TabPane>
            <Tabs.TabPane key="2" tab="技能清单">
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('service_info', {
                  initialValue: worker.service_info
                })(
                  <ServiceInfo />
                )}

              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('skill_list', {
                  initialValue: worker.skill_list
                })(
                  <SelectSkill />
                )}

              </Form.Item>
              <Form.Item
                label="其他技能">
                {getFieldDecorator('custom_skill', {
                  initialValue: worker.custom_skill,
                })(
                  <Input placeholder="技能描述" />
                )}
              </Form.Item>
            </Tabs.TabPane>
            {/* <Tabs.TabPane key="3" tab="服务范围">
              服务范围
            </Tabs.TabPane> */}
          </Tabs>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </div>
        </Form>
      </div>
    )
  }
}

const WorkerDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={820}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <WorkerForm {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'WORKER_INFO_DIALOG',
})(WorkerDialog)
